module.exports={cookies:"Cookie",help:"Aiuto",privacy:"Privacy (AGGIORNATO)",signInWithId:"Accedi con un Adobe ID",termsOfUse:"Condizioni d’uso"};